export const COW_STATUS_TRANSLATIONS = {
  title: "Comprendiendo el Estado de tu Ganado",

  howStatusUpdatesWork: {
    title: "¿Cómo Funciona?",
    description:
      "Seguimos automáticamente el estado de tu ganado basado en lo que registras. Cada estado se actualiza cada vez que registras un evento relevante.",
  },

  statusTypes: {
    title: "Tipos de Estado",

    healthy: {
      title: "Saludable",
      meaning: "Muestra si tu ganado está en buen estado de salud ahora.",
      becomesTrue: "Cuando registras un control de salud positivo",
      becomesFalse:
        "Cuando registras un control de salud negativo, tratamiento de enfermedad, tratamiento de lesión, cirugía, control post-operatorio o vacunación",
    },

    underTreatment: {
      title: "Bajo Tratamiento",
      meaning:
        "Muestra si tu ganado está recibiendo actualmente atención médica o medicamentos.",
      becomesTrue:
        "Cuando registras cualquier atención médica como vacunaciones, tratamientos de enfermedades, desparasitación, tratamientos de heridas, cirugías, controles post-operatorios o administración de suplementos",
      becomesFalse: "Cuando registras un control de salud positivo",
    },

    pregnant: {
      title: "Gestante",
      meaning: "Muestra si tu ganado está esperando un ternero.",
      becomesTrue: "Cuando registras un control de gestación positivo",
      becomesFalse:
        "Cuando registras un control de gestación negativo, aborto, parto, inseminación, apareamiento natural o detección de celo",
    },

    inHeat: {
      title: "En Celo",
      meaning:
        "Muestra si tu ganado está en el ciclo reproductivo y listo para aparearse.",
      becomesTrue: "Cuando registras detección de celo",
      becomesFalse:
        "Cuando registras un control de gestación positivo, inseminación o apareamiento natural",
    },

    lactating: {
      title: "Lactante",
      meaning: "Muestra si tu ganado está produciendo leche actualmente.",
      becomesTrue: "Cuando registras el inicio de la lactancia",
      becomesFalse: "Cuando registras el final de la lactancia o el secado",
    },
  },

  labels: {
    whatItMeans: "¿Qué significa?",
    whenItBecomesTrue: "¿Cuándo se activa?",
    whenItBecomesFalse: "¿Cuándo se desactiva?",
  },
}
